import { useState } from 'react';
import { useRouter } from 'next/router';

import { Feedback } from '@playbooks/molecules/feedbacks';
import { Pagination } from '@playbooks/molecules/paginations';

import { BlogGridCard } from 'components/blog/blog-card';
import { useAction, useMounted, useQuery } from 'hooks';

const BlogsDisplaySection = ({ ssr, rootLink = '' }) => {
	const [articles, setArticles] = useState(ssr.data || []);
	const [params, setParams] = useState<any>({});
	const [meta, setMeta] = useState(ssr.meta || { page: 0, pageSize: 0, totalRecords: 0 });
	const router = useRouter();

	// Hooks
	useMounted(() => {
		fetchData();
	}, [params]);
	useMounted(() => {
		setArticles(ssr.data || []);
		setMeta(ssr.meta || {});
	}, [ssr.data, ssr.meta]);

	// Methods
	const [fetchData, loading] = useQuery(async () => {
		// await sleep(30000);
		router.push({ query: { ...router.query, page: params.page } });
	});
	const [fetchMore, moreTask] = useAction(async page => {
		// await sleep(30000);
		router.push({ query: { ...router.query, page } });
	});

	// Render
	return (
		<section className='w-full py-10 md:py-14'>
			<div className='w-full'>
				{articles.length ? (
					<div
						aria-busy={loading || undefined}
						className='grid grid-cols-1 gap-5 transition-opacity md:grid-cols-2 lg:grid-cols-3 aria-busy:opacity-60'>
						{articles.map((article, index) => (
							<div key={article.uuid} className={index === 0 ? 'md:col-span-2' : ''}>
								<BlogGridCard article={article} featured={index === 0} rootLink={rootLink} />
							</div>
						))}
					</div>
				) : (
					<Feedback layout='drop' icon='newspaper' />
				)}
			</div>
			<div className='flex-between w-full gap-2 pt-10'>
				<Pagination
					layout='slider'
					meta={meta}
					params={params}
					setParams={setParams}
					taskRunning={moreTask.running}
					onClick={fetchMore}
				/>
			</div>
		</section>
	);
};
export { BlogsDisplaySection };
